<div class="d-flex align-items-center top-tools-buttons" style="top: 70px !important;">
  <button (click)="goBack()" class="action back" kendoButton [icon]="'arrow-chevron-left'"><span class="text">{{'back'|translate}}</span>
  </button>
</div>

<div class="form-content">
  <form action="" method="post" accept-charset="utf-8" (ngSubmit)="submit(form)" #form="ngForm">
    <div class="col-md-7 col-12 form-box p-0 ">
      <div class="form-section collapse-section open">
        <div class="d-flex align-items-center justify-content-between collapse-header">
          <h6 class="text-collapse m-0">{{'Technischer Support'|translate}}</h6>
          <div class="d-flex">
            <button kendoButton type="button" class="btn btn-primary btn-collapse" [icon]="'arrow-chevron-down'"></button>
          </div>
        </div>
        <div class="form-section">
          <div class="row">
            <div class="col-md-8">
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <h3>{{ ticket.subject }}</h3>
                <div #anchor>
                  <div *ngIf="isUserInGroup">
                    <svg (click)="showInfoLogs = true;" style="width:25px; cursor: pointer;" viewBox="0 0 512 512"><path d="M288 352h32v32H192v-32h32v-96h-32v-32h96v128zm0-224h-64v64h64v-64zm192 128c0 123.7-100.3 224-224 224S32 379.7 32 256 132.3 32 256 32s224 100.3 224 224zm-32 0c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg>
                  </div>
                </div>

                <!-- TICKET CREATED BY HISTORY -->
                <kendo-popup [anchor]="anchor" (anchorViewportLeave)="showInfoLogs = false" *ngIf="showInfoLogs" style="width: 500px;">
                  <div class="content">
                    <h3 class="popover-header"><b>{{'User Information'|translate}}</b><i class="fas fa-times" (click)="showInfoLogs = false;" style="cursor: pointer; float: right;"></i></h3>
                    <div class="popover-body">
                      <div class="popover_content col-md-12" style="display: flex; justify-content: space-between; flex-direction: row;">
                        <div class="row">
                          <div class="col-md-12" style="margin-top: 10px;"><b>{{'Full Name'|translate}}: </b>{{ticket?.user?.fullName}}</div>
                          <div class="col-md-12" style="margin-top: 10px;"><b>{{'E-mail'|translate}}: </b>{{ticket?.user?.email}}</div>
                          <div class="col-md-12" style="margin-top: 10px;"><b>{{'Phone Business Mobile'|translate}}: </b>{{ticket?.user?.telNrBusiness}}</div>
                          <div class="col-md-12" style="margin-top: 10px;"><b>{{'Telephone Business Landline'|translate}}: </b>{{ticket?.user?.telNrLandline}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </kendo-popup>
                <!-- TICKET CREATED BY HISTORY -->
              </div>
              <div>
                <div class="d-flex justify-content-between pt-2 mt-4" style="border-top: 1px solid #eeeeee;">
                  <strong class="comment-author">{{ ticket?.user?.name }} {{ ticket?.user?.surname }}</strong>
                  <time data-datetime="calendar"> {{ ticket.created_at | date: 'dd.MM.yyyy HH:mm' }}</time>
                </div>
                <div [innerHTML]="ticket.description" class="ticket-description"></div>
                <div class="d-flex col-md-12">
                  <div class="row">
                    <div *ngFor="let f of ticket.files" class="col-md-4">
                      <img documentAppendToken src="{{url.ticketFileUrl}}/{{f.fileName}}" alt="" (click)="openReplyPhoto(f.fileName)" style="width: 250px; margin-right: 20px;">
                    </div>
                  </div>
                </div>
              </div>
              <div *ngFor="let item of ticketReplies">
                <div class="d-flex justify-content-between pt-2 mt-4" style="border-top: 1px solid #eeeeee;">
                  <strong class="comment-author">{{ item.user }}</strong>
                  <time data-datetime="calendar"> {{ item.created_at | date: 'dd.MM.yyyy HH:mm' }}</time>
                </div>
                <div [innerHTML]="item.description" class="ticket-description"></div>
                <div class="d-flex col-md-12">
                  <div class="row">
                    <div *ngFor="let f of item.files" class="col-md-4">
                      <img documentAppendToken src="{{url.ticketFileUrl}}/{{f.fileName}}" alt="" (click)="openReplyPhoto(f.fileName)" style="width: 250px; margin-right: 20px;">
                    </div>
                  </div>
                </div>
              </div>

              <!-- NOTE -->
              <div *ngIf="isUserInGroup" style="margin-top: 100px;">
                <button (click)="addNoteClicked()" class="btn-save" primary="true" kendoButton type="button">{{'Supporter Notiz'|translate}}</button>
              </div>
              <!-- NOTE -->

              <div *ngIf="isUserInGroup || isAuthor" style="margin-top: 50px;">
                <div class="hasValue form-group" [class.has-error]="description.invalid && (description.dirty || description.touched)">
                  <label>{{'description'|translate}} *</label>
                  <kendo-editor [(ngModel)]="newReply.description" #description="ngModel" name="description" required style="min-height: 500px; height: 500px;">
                    <kendo-toolbar>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                      <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                      <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                      <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                      <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                      <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
                    </kendo-toolbar>
                  </kendo-editor>
                </div>
              </div>
              <div *ngIf="isUserInGroup || isAuthor" class="form-row">
                <div class="form-group mt-2 col-md-12 image-upload">
                  <h6>{{'place files here to upload them'|translate}}</h6>
                  <ngx-dropzone [multiple]="false" (change)="onFilesAdded($event)" style="max-width: 400px; max-height: 60px;">
                    <ngx-dropzone-label><i class="fa fa-upload" aria-hidden="true"></i></ngx-dropzone-label>
                  </ngx-dropzone>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6 d-flex flex-wrap filesection-upload">
                  <div *ngFor="let f of newReply.files" class="file-row d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <a class="d-block cursor-pointer" (click)="openReplyPhoto(f.fileName)">{{ f.originalName}}</a>
                    </div>
                    <i class="fa fa-times cursor-pointer" (click)="deleteFile(f)" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div *ngIf="isUserInGroup || isAuthor" class="form-group d-flex justify-content-end">
                <button type="submit" class="btn-save" [disabled]="onSubmit || form.invalid" kendoButton primary="true"><i *ngIf="onSubmit" class="fa fa-spinner fa-spin"></i>{{'save'|translate}}</button>
              </div>
            </div>
            <div class="col-md-4" style="border-left: 1px solid #e7e7e7;">
              <div *ngIf="isUserInGroup">
                <div class="form-group d-flex hasValue">
                  <label>{{'status'|translate}}:</label>
                  <kendo-dropdownlist (valueChange)="statusChanged()" class="input-min-size" [(ngModel)]="ticket.status" name="statusType" required [(value)]="ticket.status" [textField]="'name'" [valueField]="'id'" [data]="statusTypes"></kendo-dropdownlist>
                </div>
                <div class="form-group d-flex hasValue">
                  <label>{{"category"| translate}}:</label>
                  <kendo-dropdownlist (valueChange)="groupChanged()" class="input-min-size" [(ngModel)]="ticket.ticket_category_id" name="groupTypes" required [(value)]="ticket.ticket_category_id" [textField]="'name'" [valueField]="'id'" [data]="groupTypes"></kendo-dropdownlist>
                </div>
                <div *ngIf="ticket.type == 'IT-Ticket'" class="form-group d-flex hasValue">
                  <label>{{"subCategory"| translate | titlecase }}</label>
                  <kendo-dropdownlist (valueChange)="subcategoryChanged()" class="input-min-size" [(ngModel)]="ticket.ticket_subcategory_id" name="subcategoryTypes" required [(value)]="ticket.ticket_subcategory_id" [textField]="'name'" [valueField]="'id'" [data]="subcategoryTypes"></kendo-dropdownlist>
                </div>
                <div class="form-group d-flex hasValue">
                  <label>{{'Art'| translate | titlecase }}</label>
                  <kendo-dropdownlist (valueChange)="artChanged()" name="art" [data]="artArray" [textField]="'name'" [valueField]="'id'" ngModel [(ngModel)]="ticket.art" [(value)]="ticket.art" required></kendo-dropdownlist>
                </div>
                <div class="form-group d-flex hasValue">
                  <label>{{'Zugewiesen an'|translate}}:</label>
                  <kendo-dropdownlist (valueChange)="assignToUser()" [filterable]="true" [kendoDropDownFilter]="{caseSensitive: false,operator: 'contains'}" class="input-min-size" [(ngModel)]="ticket.assigned_user_id" name="assigned_user_id" [textField]="'fullName'" [valueField]="'id'" [data]="users_of_group"></kendo-dropdownlist>
                </div>
                <kendo-button
                  themeColor="tertiary"
                  class="mb-4"
                  size="large"
                  *ngIf="!ticket.is_sync_with_jira"
                  icon="arrow-rotate-cw"
                  (click)="toggleTicketSyncModal()"
                >
                  Sync to Jira
                </kendo-button>
              </div>



              <div class="col-md-12">
                <div *ngIf="ticket.is_sync_with_jira"
                     style="display: flex; justify-content: space-between; align-items: center">
                  <p>Jira Status</p>
                  <p>
                    <kendo-chip
                      *ngIf="jiraStatus"
                      [themeColor]="jiraChipColor()"
                      [label]="ticket.jira_status_name">
                    </kendo-chip>
                  </p>
                </div>

                <div *ngIf="ticket.assigned_user_id !== null" style="display: flex; justify-content: space-between;">
                  <p>{{'Zugewiesener Benutzer'|translate}}: </p>
                  <p>{{ticket.assigned_user_id?.fullName}}</p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p>{{'Ticketnummer'|translate}}: </p>
                  <p>{{ticket.id}}</p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p>{{'Ticket status'|translate}}: </p>
                  <p>{{ticket.status?.id}}</p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p>{{'Erstellt am'|translate}}: </p>
                  <p>{{ticket.created_at | date:'dd.MM.yyyy HH:mm'}}</p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p>{{'Aktualisiert'|translate}}: </p>
                  <p>{{(lastReplier?.updated_at ?? ticket.updated_at) |  date:'dd.MM.yyyy HH:mm'}}</p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p>{{'Priorität'|translate}}: </p>
                  <p>{{ticket.priority}}</p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p>{{"category"| translate}}: </p>
                  <p>{{ticket.ticket_category}}</p>
                </div>
                <div *ngIf="ticket.type == 'IT-Ticket'" style="display: flex; justify-content: space-between;">
                  <p>{{"subCategory"| translate}}: </p>
                  <p>{{ticket.ticket_subcategory}}</p>
                </div>
                <div *ngIf="isUserInGroup" style="display: flex; justify-content: space-between;">
                  <p>{{'Gruppe'|translate}}: </p>
                  <p><span *ngFor="let item of ticket.groups;let i = index;">{{item.name}}<span *ngIf="ticket.groups.length-1 !== i">, </span></span></p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p>{{'Antworten'|translate}}: </p>
                  <p>{{ticketReplies?.length}}</p>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <p *ngIf="displayLastReplier">{{'Last Replier'|translate}}: </p>
                  <p>{{lastReplier?.user}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<kendo-dialog title="{{'Supporter Notiz'|translate}}" *ngIf="addNote" (close)="addNoteClosed()" style="z-index: 99999 !important;" [minWidth]="350" [width]="1000">
  <div style="display: flex; justify-content: end; margin-bottom: 30px;">
    <button type="button" *ngIf="historySection" class="btn-save mr-0" primary="true" kendoButton (click)="addNoteSectionClicked()">{{'Add Note'|translate}}</button>
    <button type="button" *ngIf="!historySection" class="btn-save mr-0" primary="true" kendoButton (click)="historySectionClicked()">{{'history'|translate}} <span class="history-number">{{ticketHistoryNumber}}</span> </button>
  </div>
  <div *ngIf="addNoteSection">
    <div class="hasValue form-group " [class.has-error]="comment.invalid && (comment.dirty || comment.touched)">
      <label>{{'comment'|translate}} *</label>
      <textarea rows="7" cols="50" type="text" [(ngModel)]="ticketNote.comment" required class="mnc-control height-auto" ngModel name="comment" #comment="ngModel"></textarea>
    </div>
    <div class="col-md-12 form-group" style="display: flex; padding: 0;">
      <div class="form-group col-md-6 image-upload" style="padding: 0 5px 0 0;">
        <div *ngIf="ticketNote.file_one_modified_name" class="photo-border">
          <img documentAppendToken src="{{ url.projectImageUrl }}/{{ticketNote.file_one_modified_name}}" style="object-fit: contain;" width="100%" height="250" />
        </div>
        <ngx-dropzone *ngIf="!ticketNote.file_one_modified_name" style="min-height: 100px;" (change)="noteFileOne($event)">
          <ngx-dropzone-label><i class="fa fa-upload" aria-hidden="true"></i></ngx-dropzone-label>
        </ngx-dropzone>
      </div>
      <div class="form-group col-md-6 image-upload" style="padding: 0 0 0 5px;">
        <div *ngIf="ticketNote.file_two_modified_name" class="photo-border">
          <img documentAppendToken src="{{ url.projectImageUrl }}/{{ticketNote.file_two_modified_name}}" style="object-fit: contain;" width="100%" height="250" />
        </div>
        <ngx-dropzone *ngIf="!ticketNote.file_two_modified_name" style="min-height: 100px;" (change)="noteFileTwo($event)">
          <ngx-dropzone-label><i class="fa fa-upload" aria-hidden="true"></i></ngx-dropzone-label>
        </ngx-dropzone>
      </div>
    </div>
  </div>
  <div *ngIf="historySection">
    <div class="form-row">
      <div class="form-group col-md-12">
        <table class="table ">
          <thead>
            <tr>
              <th>{{'user'|translate}}</th>
              <th>{{'comment'|translate}}</th>
              <th>{{'file one'|translate}}</th>
              <th>{{'file two'|translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let noteHistory of ticketHistoryData">
              <td>{{noteHistory?.users[0].name}} {{noteHistory?.users[0].surname}}</td>
              <td>{{noteHistory?.comment }}</td>
              <td class="cursor-pointer"><a (click)="openHistoryPhoto(noteHistory.file_one_modified_name)" class="d-block mr-2"> {{ noteHistory.file_one_original_name}}</a></td>
              <td class="cursor-pointer"><a (click)="openHistoryPhoto(noteHistory.file_two_modified_name)" class="d-block mr-2"> {{ noteHistory.file_two_original_name}}</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn-save" (click)="submitNewNote()" kendoButton primary="true"><i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i> {{'yes'|translate}}</button>
    <button class="btn-cancel" kendoButton (click)="addNoteClosed()" type="button">{{'no'|translate}}</button>
  </div>
</kendo-dialog>

<div *ngIf="imageEditor.show">
  <app-pspdfkit [saveUrl]="imageEditor.saveUrl" [readUrl]="imageEditor.readUrl" [fileName]="imageEditor.fileName" (closed)="onEditorClosed($event)"></app-pspdfkit>
</div>

<div *ngIf="imageEditorReply.show" >
  <app-pspdfkit [saveUrl]="imageEditorReply.saveUrl" [readUrl]="imageEditorReply.readUrl" [fileName]="imageEditorReply.fileName" (closed)="onEditorReplyClosed($event)"></app-pspdfkit>
</div>

<!-- PHOTO HISTORY INFO -->
<kendo-window title="{{'Photo'|translate}}" *ngIf="historyPhotoOpen" (close)="closeHistoryPhoto()" [minWidth]="auto" [width]="auto" [top]="30">
  <div class="modal-body">
    <img documentAppendToken [src]="photoView">
  </div>
</kendo-window>
<!-- PHOTO HISTORY INFO -->

<!-- PHOTO REPLY INFO -->
<kendo-window title="{{'Photo'|translate}}" *ngIf="replyPhotoOpen" (close)="closeReplyPhoto()" [minWidth]="auto" [width]="auto" [top]="30">
  <div class="modal-body">
    <img documentAppendToken [src]="photoReplyView">
  </div>
</kendo-window>
<!-- PHOTO REPLY INFO -->

<kendo-dialog
  title="Sync the data with ticket"
  [width]="1200"
  [height]="800"
  *ngIf="isTicketSyncModalOpen"
  (close)="toggleTicketSyncModal()"
>
  <app-ticket-jira-sync-modal
    [context]="jiraSyncContext()"
    (onSubmitToParent)="onJiraIssueCreated()"
  />
</kendo-dialog>
